import { defineStore } from 'pinia'

export const useDarkModeStore = defineStore('darkMode', {
  state: () => ({
    isDark: localStorage.getItem('theme') === 'dark'
  }),
  actions: {
    toggleDarkMode() {
      this.isDark = !this.isDark
      localStorage.setItem('theme', this.isDark ? 'dark' : 'light')

      this.applyTheme()
    },
    applyTheme() {
      document.querySelector('body').classList.toggle('dark', this.isDark)
      document.documentElement.classList.toggle('dark', this.isDark)
    },
    deactivate() {
      document.querySelector('body').classList.remove('dark')
      document.documentElement.classList.remove('dark')
    }
  }
})